import React from 'react';
import { Link } from 'react-router-dom';

// TODO
// categories

const ShopSection = ({ products }) => {
  return (
    <>
      <div className='container'>
        <div className='section'>
          <div className='row'>
            <div className='col-lg-12 col-md-12 article'>
              <div className='shopcontainer row'>
                {products?.length > 0 ? (
                  products.map((product) => (
                    <div
                      className='shop col-lg-4 col-md-6 col-sm-6'
                      key={product._id}
                    >
                      <div className='border-product'>
                        <Link to={`/products/${product._id}`}>
                          <div className='shopBack'>
                            <img src={product.image} alt={product.name} />
                          </div>
                        </Link>

                        <div className='shoptext'>
                          <h3 className='text-center'>
                            {product?.category[0]}
                          </h3>
                          <p className='text-center'>
                            <Link to={`/products/${product._id}`}>
                              {product.name}
                            </Link>
                          </p>
                          {/* <Rating
                          value={product.rating}
                          text={`${product.numReviews} reviews`}
                        /> */}
                          <h3 className='text-center'>
                            {product?.price.toString().replace('.', ',')}
                            {product?.price
                              .toString()
                              .replace('.', ',')
                              .split(',')[1]
                              ? product?.price
                                  .toString()
                                  .replace('.', ',')
                                  .split(',')[1].length === 1
                                ? '0'
                                : ''
                              : ',00'}{' '}
                            €
                          </h3>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    className='d-flex flex-column justify-content-center align-items-center'
                    style={{ minHeight: '200px', width: '100%' }}
                  >
                    <h4 className='text-center'>
                      No disponemos de ningún productos que cumpla los
                      parámetros especificados.
                    </h4>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopSection;
